import { render } from "./regulation.vue?vue&type=template&id=51a4e90b&ts=true"
import script from "./regulation.vue?vue&type=script&lang=ts"
export * from "./regulation.vue?vue&type=script&lang=ts"

import "./regulation.vue?vue&type=style&index=0&id=51a4e90b&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__